module.exports = __webpack_public_path__ + "img/wps__blanco.329492e3.svg";